// extracted by mini-css-extract-plugin
module.exports = {"shapes":"shapes_shapes__3IHhU","colorPicker":"shapes_colorPicker__3rXql","colorPickerBtn":"shapes_colorPickerBtn__3Ymfn","picker":"shapes_picker__2AcFn"};